import React from 'react';
import { Download } from 'lucide-react';

const Header = () => {
  return (
    <header className="fixed top-0 left-0 right-9 z-50 px-4 md:px-8 py-6">
      <div className="max-w-7xl mx-auto flex justify-end">
        <a
          href="/warren_jonas_resume.pdf"
          download
          className="group flex items-center gap-2 px-6 py-3 rounded-xl bg-zinc-900/40 backdrop-blur-md border border-zinc-800 hover:border-purple-500/50 hover:bg-zinc-800/50 transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/20"
        >
          <span className="text-zinc-300 group-hover:text-purple-300 font-medium transition-colors">
            Resume
          </span>
          <Download className="w-5 h-5 text-zinc-400 group-hover:text-purple-400 transition-colors" />
        </a>
      </div>
    </header>
  );
};

export default Header;
